import { render, staticRenderFns } from "./PlanContent.vue?vue&type=template&id=772db613"
import script from "./PlanContent.vue?vue&type=script&lang=js"
export * from "./PlanContent.vue?vue&type=script&lang=js"
import style0 from "./PlanContent.vue?vue&type=style&index=0&id=772db613&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports